import {getSafeRedirectUrl} from '~shared/utils/get-safe-redirect-url';

export function getRedirectURL(): string {
    const {searchParams} = new URL(window.location.href);
    const retpath = searchParams.get('retpath');

    const retpathUrl = new URL(retpath || '/', window.location.origin);
    retpathUrl.searchParams.set('skipPromo', '1');

    return getSafeRedirectUrl(retpathUrl.href);
}
